import { InjectionToken } from '@angular/core';

import { DoodEntityModel } from '@core/models/entity.model';

/** Runtime VM emitted by `ShopsMapBlock` data sources. */
export type ShopsMapBlockViewModel = {
  /** `undefined` while loading; an array (possibly empty) once loaded. */
  shops: DoodEntityModel[] | undefined;
};

export const SHOPS_MAP_BLOCK_LOADING_VM: ShopsMapBlockViewModel = {
  shops: undefined,
};

export interface ShopsMapBlockDataSource {
  readonly vm$: import('rxjs').Observable<ShopsMapBlockViewModel>;
}

export const SHOPS_MAP_BLOCK_DATA_SOURCE = new InjectionToken<ShopsMapBlockDataSource>(
  'SHOPS_MAP_BLOCK_DATA_SOURCE',
);
